module.exports = __webpack_public_path__ + "img/3x.3ca7a9d.jpg";